import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import '../styles/AuthCallback.css';

function AuthCallback() {
  const { checkAuth } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    handleCallback();
  }, []);

  async function handleCallback() {
    try {
      const params = new URLSearchParams(window.location.search);
      const token = params.get('token');
      const authError = params.get('auth_error');

      console.log('AuthCallback - token:', token ? 'present' : 'missing');
      console.log('AuthCallback - authError:', authError);

      if (authError) {
        setError(getErrorMessage(authError));
        setTimeout(() => {
          window.location.href = '/';
        }, 3000);
        return;
      }

      if (!token) {
        console.error('No token in URL params');
        setError('No authentication token received');
        setTimeout(() => {
          window.location.href = '/';
        }, 3000);
        return;
      }

      // Store token in localStorage
      console.log('Storing token in localStorage...');
      localStorage.setItem('auth_token', token);
      console.log('Token stored. Verifying with server...');

      // Verify token and update auth context
      await checkAuth();
      console.log('checkAuth completed successfully');

      // Small delay to ensure state updates
      await new Promise(resolve => setTimeout(resolve, 500));

      // Redirect to home
      console.log('Redirecting to home...');
      window.location.href = '/';
    } catch (err) {
      console.error('Auth callback error:', err);
      setError('Failed to complete authentication');
      setTimeout(() => {
        window.location.href = '/';
      }, 3000);
    }
  }

  function getErrorMessage(errorCode) {
    const errorMessages = {
      'access_denied': 'You cancelled the login process',
      'invalid_state': 'Invalid authentication state. Please try again.',
      'missing_params': 'Missing authentication parameters',
    };

    return errorMessages[errorCode] || `Authentication error: ${errorCode}`;
  }

  return (
    <div className="auth-callback-container">
      <div className="auth-callback-content">
        {error ? (
          <>
            <div className="auth-callback-icon error">✕</div>
            <h2 className="auth-callback-title error">Authentication Failed</h2>
            <p className="auth-callback-message">{error}</p>
            <p className="auth-callback-redirect">Redirecting to home...</p>
          </>
        ) : (
          <>
            <div className="auth-callback-spinner"></div>
            <h2 className="auth-callback-title">Completing Login...</h2>
            <p className="auth-callback-message">Please wait while we sign you in</p>
          </>
        )}
      </div>
    </div>
  );
}

export default AuthCallback;
